import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import sectionGreyBg from '../../assets/images/bg_pattern.svg';
import sectionGreenBg from '../../assets/images/section-green.webp';

import { Mailto, SanitizedHTML } from '../../utils/Helper';
import SocialLinks from '../../components/SocialLinks';
import Skeleton from '../../components/skeleton/Skeleton';
import { usePageContent } from '../../hooks/usePageContent';

const Info = ({ page }) => {
    const { content, isLoading, error } = usePageContent( page?.id );
    
    if ( isLoading ) {
        return (
            <section id="contact" className="section" style={{ backgroundImage: `url(${sectionGreyBg})` }}>
                <div className="section-decoration top" style={{ backgroundImage: `url(${sectionGreenBg})`, height: '35px' }} />
                <Container>
                    <Skeleton type="contact" />
                </Container>
            </section>
        );
    }

    const ContactInfo = ({ content }) => (
        <>
            <h3 className="mb-4 pt-4 text-5 fw-500 text-dark">Contact me</h3>
            <Row>
                <ContactDetail
                    label="Phone"
                    value={content?.phone_number}
                    delay="0s"
                />
                <ContactDetail
                    label="Email"
                    value={
                        <Mailto
                            email={content?.email_address}
                            subject="Hello"
                            body="Hello Jinesh P.V"
                        >
                            {content?.email_address}
                        </Mailto>
                    }
                    delay="0.2s"
                />
                <ContactDetail
                    label="From"
                    value={content?.place}
                    delay="0.4s"
                />
            </Row>
        </>
    );

    const ContactDetail = ({ label, value, delay }) => (
        <Col lg={12} className="wow fadeInUp" data-wow-delay={delay}>
            <p className="text-muted fw-500 mb-0">{label}:</p>
            <p className="text-4 text-dark fw-500 mb-0">{value}</p>
            {label !== 'From' && <hr />}
        </Col>
    );

    return (
        <section id="contact" className="section"  style={{ backgroundImage: `url(${ sectionGreyBg })` }}>
            <div className="section-decoration top" style={{ backgroundImage: `url(${ sectionGreenBg })`, height: '35px' }}></div>
            <Container>
                { error ? (
                    <div className="g-5 text-danger mt-5">
                        <strong>Error:</strong> {error}
                    </div>
                ) : (
                    <Row className="g-5 mt-5">
                        <Col lg={8} className="wow fadeInUp">
                            { content?.content && ( <SanitizedHTML className="text-3 post-content" html={ content.content } tag="p" /> )}
                        </Col>                           
                        <Col lg={4}>
                            <div className="contact-info rounded-2">
                                <div className="position-relative">
                                    <ContactInfo content={content} />
                                </div>
                                <div className="mt-5 position-relative">
                                    <h3 className="mb-4 pt-4 text-5 fw-500 text-dark">Social me</h3>
                                    <SocialLinks />
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>
        </section>
    );
};

export default Info;